import type { IBorderOuter } from './BorderOuter'

import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'

export const BorderOuterSC = styled.div<IBorderOuter>`
  display: flex;
  width: fit-content;
  border-style: solid;
  border-image-slice: 1;
  border-width: ${({ borders }) =>
    borders?.length ? borders.map((border) => `${border}px`).join(' ') : 0};
  border-color: ${({ borderColor }) => `var(${borderColor})`};
  border-image-source: ${({ borderColorGradient }) =>
    `var(${borderColorGradient})`};
  color: ${({ borderColorGradient }) => `var(${borderColorGradient})`};
  border-radius: ${({ corners }) => (corners ? `var(${corners})` : 0)};
  //-webkit-mask - property added border radius for border-image-source
  mask: ${({ corners }) =>
    corners
      ? `linear-gradient(var(${COLOR.TEXT_ICON_CONSTANT_LIGHT}) 0 0) padding-box, 
     linear-gradient(var(${COLOR.TEXT_ICON_CONSTANT_LIGHT}) 0 0)`
      : 'none'};
  -webkit-mask: ${({ corners }) =>
    corners
      ? `linear-gradient(var(${COLOR.TEXT_ICON_CONSTANT_LIGHT}) 0 0) padding-box, 
     linear-gradient(var(${COLOR.TEXT_ICON_CONSTANT_LIGHT}) 0 0)`
      : 'none'};
`
